"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="hero" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background pb-40">
      {}
      <div className="absolute inset-0 z-0 h-full w-full">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/cartagena_sunset_poster.png">
          <source src="/video/cartagena_sunset_loop.mp4" type="video/mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-black/40 mix-blend-multiply" />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-30 mix-blend-overlay" />
      </div>

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center px-6 text-center">
        {}
        <h1 className={`mb-6 font-default text-6xl font-light leading-none text-secondary transition-all duration-1000 ease-out md:text-8xl lg:text-9xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Cartagena
        </h1>

        {}
        <p className={`mb-10 font-mono text-sm tracking-widest text-white/90 transition-all delay-300 duration-1000 ease-out md:text-base ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
        letterSpacing: "0.2em"
      }}>
          THE JEWEL OF THE CARIBBEAN
        </p>

        {}
        <div className={`transition-all delay-500 duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <Button asChild size="lg" className="bg-primary text-primary-foreground shadow-lg shadow-primary/20 transition-all duration-300 hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/40">
            <Link to="/CartagenaPage">Explore the City</Link>
          </Button>
        </div>
      </div>
    </section>;
}